module.exports = __webpack_public_path__ + "img/20_BC21_find_a_mole_model.239d3bc4.jpg";